import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";
import { ThemedXIcon } from "assets/CXFIcons/Static";

export const DeleteScheduleDialog = ({
  showDialog,
  closeDeleteDialog,
  schedule,
  deleteSchedule,
  isInUse,
  useInFlows,
  isCheckFailed
}) => {
  const { t } = useTranslation("flowDesigner");

  return (
    <Dialog
      open={showDialog}
      onClose={closeDeleteDialog}
      aria-labelledby="deleteScheduleDialogTitle"
      aria-describedby="deleteScheduleDialogDescription"
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle
        id="deleteScheduleDialogTitle"
        sx={{
          marginBottom: "20px",
          padding: "32px 24px 0 24px !important",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        className="white-to-dark"
      >
        <SoftBox display="flex" alignItems="center">
          <ThemedTrashIcon sx={{ fontSize: "16px !important", marginRight: "16px" }} />
          Trash
        </SoftBox>
        <IconButton onClick={closeDeleteDialog}>
          <ThemedXIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "0 32px 24px"
        }}
      >
        {isCheckFailed && (
          <>
            <SoftBox
              className="warning-label"
              sx={{
                alignItems: "center",
                backgroundColor: "#FFEDED",
                border: "0.5px solid #E53E3E",
                display: "flex",
                borderRadius: "9px",
                color: "#E53E3E",
                minHeight: "59px",
                justifyContent: "center",
                marginBottom: "20px"
              }}
            >
              <Icon sx={{ fontSize: "16px !important", marginRight: "16px", color: "#E53E3E" }}>warning</Icon>
              <SoftTypography
                sx={{
                  color: "#E53E3E",
                  fontSize: "14px",
                  fontWeight: 600
                }}
              >
                Usage could not be verified. Please try again before deleting.
              </SoftTypography>
            </SoftBox>
          </>
        )}

        {!isCheckFailed && isInUse && (
          <>
            <SoftBox
              className="warning-label"
              sx={{
                alignItems: "center",
                backgroundColor: "#FFEDED",
                border: "0.5px solid #E53E3E",
                display: "flex",
                borderRadius: "9px",
                color: "#E53E3E",
                minHeight: "59px",
                justifyContent: "center",
                marginBottom: "20px"
              }}
            >
              <Icon sx={{ fontSize: "16px !important", marginRight: "16px", color: "#E53E3E" }}>warning</Icon>
              <SoftTypography
                sx={{
                  color: "#E53E3E",
                  fontSize: "14px",
                  fontWeight: 600
                }}
              >
                Warning: This schedule is actively being used
              </SoftTypography>
            </SoftBox>
            <SoftTypography
              className="white-to-dark"
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                marginBottom: "8px"
              }}
            >
              Flows using this schedule:
            </SoftTypography>
            <SoftBox
              sx={{
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #E6E6E6",
                borderRadius: "8px",
                padding: "8px",
                marginBottom: "16px"
              }}
            >
              {useInFlows.map(({ name }, idx) => (
                <SoftTypography key={idx} sx={{ fontSize: "14px", marginBottom: "4px" }}>
                  {name}
                </SoftTypography>
              ))}
            </SoftBox>
          </>
        )}

        {!isCheckFailed && !isInUse && (
          <DialogContentText id="deleteScheduleDialogDescription">
            {t("dialogs.delete_schedule.content")}
            &nbsp;
            <strong>{t("dialogs.delete_schedule.name", { name: schedule?.title })}</strong>?
          </DialogContentText>
        )}
      </DialogContent>
      {!isCheckFailed && !isInUse && (
        <DialogActions>
          <SoftButton variant="outlined" color="primary" onClick={closeDeleteDialog}>
            {t("buttons.cancel")}
          </SoftButton>
          <SoftButton onClick={deleteSchedule} color="primary">
            {t("buttons.delete")}
          </SoftButton>
        </DialogActions>
      )}
    </Dialog>
  );
};
